<template>
  <b-modal
    id="assign-operator-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.handover')"
    :cancel-title="$t('button.close')"
    centered
    no-close-on-backdrop
    :title="$t('general.handoverServicesTo')"
    @ok="handleOk"
  >
    <validation-observer
      ref="assignOperatorForm"
      #default="{ invalid }"
    >
      <!-- form -->
      <n-form-confirmation
        ref="formConfirmation"
        key="assignOperatorForm"
        :message="$t('alert.handoverTo', { operator: operatorName })"
        :confirm-button-text="`button.confirm`"
        :cancel-button-text="`button.no`"
        :form="$refs.assignOperatorForm"
        :disabled="invalid"
        @submit="submit"
      >
        <n-input
          v-model="data"
          :fields="formInput"
        >
          <template #userId="item">
            <b-form-group
              :key="`selection-operator-${key}`"
              :label-for="item.field.key"
              :class="item.field.class"
            >
              <validation-provider
                #default="{ errors }"
                :vid="item.field.key"
                :name="item.field.label"
                :rules="item.field.rules"
              >
                <label class="d-block">
                  {{ $t("field.operator") }}
                </label>
                <n-async-single-select
                  :ref="item.field.key"
                  v-model="user"
                  :name="item.field.key"
                  :repository="item.field.repository"
                  :selection-key="item.field.selectionKey"
                  :selection-label="item.field.selectionLabel"
                  :readonly="item.field.disabled"
                  :clearable="item.field.clearable"
                  :reduce="false"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  :always-excluded="userData.id"
                  exclude-key="id"
                  :excludes="[userData.id]"
                  @input="onChangeOperator"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </template>
        </n-input>
      </n-form-confirmation>
    </validation-observer>

    <template #modal-ok>
      <b-spinner
        v-if="loading"
        small
        label="Spinning"
      />
      <span v-else>
        {{ $t("button.handover") }}
      </span>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BFormGroup, BBadge,
} from 'bootstrap-vue'
import NInput from '@/components/NInput.vue'
import Repository from '@/repositories/RepositoryFactory'
import NFormConfirmation from '@/components/NFormConfirmation.vue'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect.vue'
import useJwt from '@/auth/jwt/useJwt'
import FormInput from './assignOperatorFormInput'

const ServiceSystemRepository = Repository.get('serviceSystem')

export default {
  components: {
    BModal,
    BSpinner,
    BFormGroup,
    BBadge,
    NFormConfirmation,
    NInput,
    NAsyncSingleSelect,
  },
  props: {
    activeChannel: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      user: '',
      data: {
        userId: '',
      },
      operatorName: '',
      key: 1,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName))
    },
  },
  methods: {
    show() {
      this.key += 1
      this.user = ''
      this.data.userId = ''
      this.operatorName = ''
      this.$bvModal.show('assign-operator-modal')
    },
    hide() {
      this.$bvModal.hide('assign-operator-modal')
    },
    onChangeOperator(data) {
      this.data.userId = data.id
      this.operatorName = data.name
    },
    handleOk(bvModal) {
      bvModal.preventDefault()
      if (this.loading) {
        return
      }

      this.$refs.assignOperatorForm.validate().then(success => {
        if (success) {
          this.$refs.formConfirmation.confirm()
        }
      })
    },
    submit() {
      this.loading = true
      ServiceSystemRepository.handover(this.data.userId)
        .then(() => {
          this.hide()
          this.$emit('success')
        })
        .catch(error => {
          if (error.response?.status === 422) {
            this.$refs.assignOperatorForm.setErrors(
              error.response?.data?.validate,
            )
          }
        })
        .then(() => {
          this.loading = false
        })
    },
  },
  setup() {
    const formInput = [...FormInput]

    return {
      formInput,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
